import { render, staticRenderFns } from "./MindoNewests.vue?vue&type=template&id=1838fbfc&"
import script from "./MindoNewests.vue?vue&type=script&lang=js&"
export * from "./MindoNewests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports